var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-0 p-4 flex items-center border-t bg-white rounded-b-lg border-gray-300 whitespace-no-wrap",class:{
    'justify-between': _vm.split,
    'justify-end': !_vm.split,
    'overflow-x-auto': _vm.scrollable
    }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }